import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "originalDraft",
    "originalDraftEdit",
    "originalDraftEditButton",
    "originalDraftSaveButton",
    "originalFinal",
    "originalFinalEdit",
    "originalFinalEditButton",
    "originalFinalSaveButton",
    "translationDraft",
    "translationDraftEdit",
    "translationDraftEditButton",
    "translationDraftSaveButton",
    "translationFinal",
    "translationFinalEdit",
    "translationFinalEditButton",
    "translationFinalSaveButton",
    "modal"
  ];
  static classes = ["hide","open"];
  static values = {savedrafturl: String, saveurl: String};

  editForm(event){
    event.preventDefault();
    const t = event.params.target;
    this.swichEdit(t);
  }

  saveDraft(event){
    event.preventDefault();
    const params = event.params;
    const targetName = params.target;
    const formData = new FormData(this.formTarget);
    formData.append("type",targetName);
    Rails.ajax({
      url: this.savedrafturlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        document.getElementById("medical_report_id").value = response.id;
        switch (targetName) {
          case "original_draft":
            this.originalDraftTarget.innerText = response.text;
            const odd = this.originalDraftEditButtonTarget.querySelector("span");
            odd.classList.remove(this.hideClass);
            this.swichEdit("originalDraft");
            break;
          case "original_final":
            this.originalFinalTarget.innerText = response.text;
            const ofd = this.originalFinalEditButtonTarget.querySelector("span");
            ofd.classList.remove(this.hideClass);
            this.swichEdit("originalFinal");
            break;
          case "translation_draft":
            this.translationDraftTarget.innerText = response.text;
            const tdd = this.translationDraftEditButtonTarget.querySelector("span");
            tdd.classList.remove(this.hideClass);
            this.swichEdit("translationDraft");
            break;
          case "translation_final":
            this.translationFinalTarget.innerText = response.text;
            const tfd = this.translationFinalEditButtonTarget.querySelector("span");
            tfd.classList.remove(this.hideClass);
            this.swichEdit("translationFinal");
            break;
        }
      }
    });
  }
  save(event){
    event.preventDefault();
    const params = event.params;
    const targetName = params.target;
    const formData = new FormData(this.formTarget);
    formData.append("type",targetName);
    Rails.ajax({
      url: this.saveurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        document.getElementById("medical_report_id").value = response.id;
        switch (targetName) {
          case "original_draft":
            this.originalDraftTarget.innerText = response.text;
            const odd = this.originalDraftEditButtonTarget.querySelector("span");
            odd.classList.add(this.hideClass);
            this.swichEdit("originalDraft");
            break;
          case "original_final":
            this.originalFinalTarget.innerText = response.text;
            const ofd = this.originalFinalEditButtonTarget.querySelector("span");
            ofd.classList.add(this.hideClass);
            this.swichEdit("originalFinal");
            break;
          case "translation_draft":
            this.translationDraftTarget.innerText = response.text;
            const tdd = this.translationDraftEditButtonTarget.querySelector("span");
            tdd.classList.add(this.hideClass);
            this.swichEdit("translationDraft");
            break;
          case "translation_final":
            this.translationFinalTarget.innerText = response.text;
            const tfd = this.translationFinalEditButtonTarget.querySelector("span");
            tfd.classList.add(this.hideClass);
            this.swichEdit("translationFinal");
            break;
        }
      }
    });
  }

  swichEdit(target){
    switch (target) {
      case "originalDraft":
        this.originalDraftTarget.classList.toggle(this.hideClass);
        this.originalDraftEditTarget.classList.toggle(this.hideClass);
        this.originalDraftEditButtonTarget.classList.toggle(this.hideClass);
        this.originalDraftSaveButtonTarget.classList.toggle(this.hideClass);
        break;
      case "originalFinal":
        this.originalFinalTarget.classList.toggle(this.hideClass);
        this.originalFinalEditTarget.classList.toggle(this.hideClass);
        this.originalFinalEditButtonTarget.classList.toggle(this.hideClass);
        this.originalFinalSaveButtonTarget.classList.toggle(this.hideClass);
        break;
      case "translationDraft":
        this.translationDraftTarget.classList.toggle(this.hideClass);
        this.translationDraftEditTarget.classList.toggle(this.hideClass);
        this.translationDraftEditButtonTarget.classList.toggle(this.hideClass);
        this.translationDraftSaveButtonTarget.classList.toggle(this.hideClass);
        break;
      case "translationFinal":
        this.translationFinalTarget.classList.toggle(this.hideClass);
        this.translationFinalEditTarget.classList.toggle(this.hideClass);
        this.translationFinalEditButtonTarget.classList.toggle(this.hideClass);
        this.translationFinalSaveButtonTarget.classList.toggle(this.hideClass);
        break;
    }
  }

  modal(event) {
    event.preventDefault();
    this.modalTarget.classList.toggle(this.openClass);
    const params = event.params;
    if(params != undefined){
      const b = this.modalTarget.querySelector("button.is-primary");
      const ns = document.getElementById("next_status");
      b.setAttribute("data-admin--reservations--edit-report-target-param",params.target);
      switch (params.target){
        case "original_draft":
          ns.innerHTML = "<span class=\"tag is-info\">レポート確認待ち</span>";
          break;
        case "original_final":
          ns.innerHTML = "<span class=\"tag is-primary\">レポート翻訳待ち</span>";
          break;
        case "translation_draft":
          ns.innerHTML = "<span class=\"tag is-primary\">レポート承認待ち</span>";
          break;
        case "translation_final":
          ns.innerHTML = "<span class=\"tag is-info\">レポート公開待ち</span>";
          break;
      }
    }
  }
}
